import { useIntl } from '@common/i18n';
import { Box } from '@common/ui-components';
import { noop } from '@utils';
import { ReactElement, useMemo } from 'react';

import { MultiSelect } from '../multi-select';
import { Value } from '../multi-select/multi-select.types';
import { HubsMultiSelectProps } from './hubs-multi-select.types';
import { hubsMultiSelectIntlIds } from './intl';

export default function HubsMultiSelect({
  hubs = [],
  selectedHubIds = [],
  setSearchedHubIds = noop,
  onChange = noop,
}: HubsMultiSelectProps): ReactElement {
  const { formatMessage } = useIntl();

  const options = useMemo(() => {
    return hubs.map((hub) => ({
      value: hub.id,
      label: hub.alias,
    }));
  }, [hubs]);

  const value = useMemo(
    () => options.filter((option) => selectedHubIds.includes(option.value)),
    [options, selectedHubIds]
  );

  const allHubsIds = hubs.map((hub) => hub.id);

  const handleChange = (selectedHubs: Value[] | null) => {
    const hubIds = selectedHubs?.map((item) => item.value) ?? [];

    if (!hubIds.length) {
      onChange(allHubsIds);
      setSearchedHubIds(allHubsIds);
      return;
    }

    onChange(hubIds);
    setSearchedHubIds(hubIds);
  };

  return (
    <Box w="24.19rem">
      <MultiSelect
        allValuesLabel={formatMessage({
          id: hubsMultiSelectIntlIds.allValuesLabel,
        })}
        name="hubs"
        onChange={handleChange}
        options={options}
        placeholder={formatMessage({
          id: hubsMultiSelectIntlIds.placeholder,
        })}
        noOptionsLabel={formatMessage({
          id: hubsMultiSelectIntlIds.noOptionsLabel,
        })}
        value={value}
      />
    </Box>
  );
}
